import { createFileRoute } from '@tanstack/react-router';
import { VaultLibrary } from '@/features/vault/components/VaultLibrary';

// /vault — the regulatory document library. `?folderId=` selects a folder NODE (the tree view);
// `?root=true` selects the Vault-root view (loose files, no folder); no param = the All-files view.
// The right side swaps in place. Auth is enforced at <AppShell> via __root.tsx. (The legacy
// `?folder=` by-name view has been retired — the tree view supersedes it.)
function validateVaultSearch(search: Record<string, unknown>): { folderId?: number; root?: boolean } {
  const raw = search.folderId;
  const folderId = typeof raw === 'number' && Number.isInteger(raw) && raw > 0 ? raw
    : typeof raw === 'string' && /^\d+$/.test(raw) ? Number(raw) : undefined;
  if (folderId) return { folderId };  // a specific folder wins over the root flag
  const root = search.root === true || search.root === 'true' || search.root === 1 || search.root === '1';
  return root ? { root: true } : {};
}

export const Route = createFileRoute('/vault')({
  validateSearch: validateVaultSearch,
  component: VaultPage,
});

function VaultPage() {
  const { folderId, root } = Route.useSearch();
  return <VaultLibrary folderId={folderId ?? null} root={!!root} />;
}
